/* 
 	* 车辆档案之基本信息组件 
 	* 描述：对应车辆的基本信息编辑
 	* 创建时间：2017-03-31
 	* 创建人：Shujuan Sun
 	* 修改人：zhanlz 
 	* 修改时间：2017-04-21
*/
<template>
	<div class="pl10px pr10px ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<br />
			<div class="col-sm-8">
				<div class="form-group">
					<label class="col-sm-2 control-label t_right">服务卡号</label>
					<div class="col-sm-4">
						<input type="text" class="form-control" readonly v-model="vehicleInfo.vehicleAccount">
					</div>
					<label class="col-sm-2 control-label t_right" disabled>服务状态</label>
					<div class="col-sm-4">
						<select class="form-control" v-model.trim="vehicleInfo.serverStatus" disabled="true">
							<option value="1">空闲中</option>
							<option value="2">已暂停</option>
							<option value="3">救援中</option>
						</select>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label t_right">服务结束日</label>
					<div class="col-sm-4">
						<input type="text" class="form-control" readonly v-model="vehicleInfo.serviceEndTime">
					</div>
					<label class="col-sm-2 control-label t_right">服务起始日</label>
					<div class="col-sm-4">
						<input type="text" class="form-control" readonly v-model="vehicleInfo.serviceStartTime">
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label t_right red">*车牌号</label>
					<div class="col-sm-4"  v-bind:class="{ 'form-group--error': $v.vehicleInfo.plateNumber.$error }">
						<vplate-input type="text" class="form-control" v-model="vehicleInfo.plateNumber" @input="$v.vehicleInfo.plateNumber.$touch()"/>
						<span class="form-group__message cus_message" v-if="!$v.vehicleInfo.plateNumber.required && $v.vehicleInfo.plateNumber.$error">车牌号为必填项</span>
					</div>
					<label class="col-sm-2 control-label t_right red">*车辆类型</label>
					<div class="col-sm-4"  v-bind:class="{ 'form-group--error': $v.vehicleInfo.style.$error }">
						<select class="form-control" v-model="vehicleInfo.style" @input="$v.vehicleInfo.style.$touch()">
							<option v-for="item in udcList" :value="item.udccode">{{item.udcname}}</option>
						</select>
						<span class="form-group__message cus_message" v-if="!$v.vehicleInfo.style.required && $v.vehicleInfo.style.$error">车辆类型为必填项</span>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-2 control-label t_right">载重量(吨)</label>
					<div class="col-sm-4">
						<input type="number" class="form-control" v-model="vehicleInfo.maximumLoadStr">
						<!-- <p v-if="!isinteger" class="cus_message form-group__message">载重量必须为整数</p> -->
					</div>
					<label class="col-sm-2 control-label t_right red">*调度电话</label>
					<div class="col-sm-4"   v-bind:class="{ 'form-group--error': $v.vehicleInfo.dispatcherPhone.$error }">
						<input type="text" class="form-control" v-model="vehicleInfo.dispatcherPhone" @input="$v.vehicleInfo.dispatcherPhone.$touch()">
						<span class="form-group__message cus_message" v-if="!$v.vehicleInfo.dispatcherPhone.required && $v.vehicleInfo.dispatcherPhone.$error">调度电话为必填项</span>
					</div>
				</div>
				
			</div>
			<div class="col-sm-4">
				<label class="col-sm-3 control-label t_right">车辆照片</label>
				<div class="col-sm-9">
					<div class="col-sm-12">
						<div class="uploadedImg t_right col-sm-3">
							<img v-if="logoSrc!==''" :src="logoSrc" class="img-responsive"/>
							<img v-if="logoSrc==''" src="../../../../assets/project/images/img_bg.jpg" class="img-responsive"/>
						</div>
						<vue-core-image-upload
							extensions="png,gif,jpeg,jpg"
							input-accept="image/jpg,image/jpeg,image/png"
							v-bind:crop="false" 
							v-on:imageuploaded="imageuploaded"						
							text=""
							inputOfFile="file"
							:url="picUrl"
							:headers="{'access-token':this.accesstoken}"
							v-bind:class="['upload-pic']"
							v-if="permission.indexOf('carFileList_uploadRescueVehiclePhoto') == -1"
							>
						</vue-core-image-upload>
						<span class=" control-label gray t_right">请上传jpg、jpeg或png格式的图片</span>
					</div>
					<!--<span>{{this.$parent.resultVehicle.plateNumber}}</span>-->
				</div>
			</div>
		</div>
		<div class="form-horizontal col-sm-8">
			<br />
			<div class="form-group">
				<label class="col-sm-4 control-label t_right ">服务项目:</label>
				<div class="col-sm-8">
					<div class="col-sm-3 control-label"  v-for="item in serviceArr" v-if="vehicleInfo.style==10||item.udccode!==1">
						<checkbox v-model="item.type">{{item.udcname}}</checkbox>
					</div>
				</div>
			</div>
		</div>
		<div class="form-horizontal ibox-content">
			<br />
			<div class="form-group">
				<div class="col-sm-12 text-right">
					<button class="btn btn-primary"  v-if="permission.indexOf('carFileList_forcedUnlockDriver') == -1" :disabled="vehicleInfo.driverName==''" @click="unBindBtn">强制解绑司机</button>
				</div>
			</div>
			<div class="form-group" >
				<label class="col-sm-1 control-label t_right">在驾司机:</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.driverName">
				</div>
				<label class="col-sm-1 control-label t_right">手机号:</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.driverPhone">
				</div>
				<label class="col-sm-1 control-label t_right">绑定时间:</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="vehicleInfo.bindTime">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_right">工作备注:</label>
				<div class="col-sm-11">
				    <textarea rows="6" class="col-sm-12" v-model="vehicleInfo.memo" maxlength="250"></textarea>
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<br />
			<div class="form-group text-center" style="position: relative;">
				<div  class="col-sm-11">
					<button v-if="permission.indexOf('carFileList_saveBasicInfo') == -1"
						class="btn btn-primary"
						@click="saveVehicle"
						:disabled="!enableSubmit">
						保存基本信息
					</button>
					<button v-if="permission.indexOf('carFileList_inIdleStatus') == -1" 
						:disabled="vehicleInfo.serverStatus == 1 || vehicleInfo.driverId=='' || vehicleInfo.driverId==0" 
						class="btn btn-primary" 
						@click="changeStatus(1)">
						切入空闲状态
					</button>
					<button v-if="permission.indexOf('carFileList_inPauseStatus') == -1" 
						:disabled="vehicleInfo.serverStatus == 2 || vehicleInfo.driverId=='' || vehicleInfo.driverId==0" 
						class="btn btn-primary" 
						@click="changeStatus(2)">
						切入暂停状态
					</button>
				</div>
				<div class="col-sm-1">
					<div class="col-sm-12 text-right">
						<button class="btn btn-primary" v-if="permission.indexOf('carFileList_deleteRescueVehicle') == -1"  @click="openModal('deleteCar')">删除车辆</button>
					</div>
					<!-- <a @click="openModal('deleteCar')">删除车辆</a> -->
				</div>
			</div>
		</div>
		<!--   弹出框子组件        -->
		<tab-modal ref="deleteCar" size="small" :scroll='scrollTop' v-on:cancel="closeModal('deleteCar')" title="提示">
				<p v-if="toShowMsg">													
					您将要删除车辆“{{vehicleInfo.plateNumber}}”，删除后该车辆将不能查询、接单。如有误删除，需与人保客服联系解除。
					您确定要继续吗？												
				</p>												
			<div slot="footer">
				<button class="btn btn-primary" @click="removeCar">确定</button>
				<button class="btn btn-primary" @click="closeModal('deleteCar')">取消</button>
		    </div>
		</tab-modal>
		<tab-modal ref="unBind" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('unBind')">
			<p v-if="toShowMsg">您将强制解除司机“{{vehicleInfo.driverName}}”与“{{vehicleInfo.plateNumber}}”的绑定关系，												
					解除后，该车辆可由其它司机上岗驾驶。													
						您确定要继续吗？</p>	
			<div slot="footer">
				<button class="btn btn-primary" @click="forceUnbind">确定</button>
				<button class="btn btn-primary" @click="closeModal('unBind')">取消</button>
		    </div>
		</tab-modal>
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal('modalMsg')">
				{{messageStr}}											
			<div slot="footer">
				<!--<button class="btn btn-primary">确定</button>-->
				<button class="btn btn-primary" @click="closeModal('modalMsg')">取消</button>
		    </div>
		</tab-modal>
	</div>
</template>
<script>

	import { OPERATE_EXCEPTION, OPERATE_SUCCESS } from 'static/message'
	import { required } from 'vuelidate/lib/validators'
	import TabModal from 'components/common/TabModal'
	import classlist from 'util/classlist'
	import VueCoreImageUpload from 'vue-core-image-upload'
	import Checkbox from 'components/common/Checkbox' 
	
	export default {
		name: 'DetailBasic',
		components: {
		   TabModal,
		   VueCoreImageUpload,
		   Checkbox
		},
		computed:{
			accesstoken:function(){
				return this.$store.state.user.accesstoken
			},
		//	logoSrc:function(){
		//		return this.vehicleInfo.vehicleLogourl
		//	},
			// isinteger:function(){
			// 	if(this.vehicleInfo.maximumLoad===''){
			// 		return true;
			// 	}
			// 	return /^[1-9]\d*$/.test(this.vehicleInfo.maximumLoad)
			// },
			enableSubmit: function() {
				return this.$v.vehicleInfo.dispatcherPhone.required &&
						this.$v.vehicleInfo.style.required &&
						this.$v.vehicleInfo.plateNumber.required;
			}
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				loadingstatus:false,
				vehicleInfo: {
					maximumLoadStr:'',				//载重量
					vehicleAccount: "",		    // 服务卡号
					serviceStartTime:'',		// 服务开始时间
					serviceEndTime:'',			// 服务结束时间
					plateNumber:'',				// 车牌号
					style:'',					// 当前款型
					trackMode:'',				//服务状态
					dispatcherPhone:'',			//调度电话
					driverName:'',				//在驾司机
					driverPhone:'',				//司机电话
					bindTime:'',				//绑定时间
					memo:'',					//工作备注
					service:'',
					vehicleLogourl:'',          //车辆图片
				},
				scrollTop: "0px",
				messageStr:"",
				
				serviceArr:[],
				vehicleId:'',
				picUrl:process.env.API_INSURANCE_ROOT +"/rescue-api/photo/upload",
				toShowMsg:false,
				udcList:[],
				logoSrc:'',
			}
		},
		beforeMount() {
			this.vehicleId=this.$parent.resultVehicle.vehicleId
			this.getUdc();
		},
		watch: {
			'vehicleInfo.brandId'(){
				this.getSerialList();
			},
			'vehicleInfo.serialId'(){
				this.getModelList();
			}
		},
		watch: {
			'vehicleInfo.brandId'(){
				this.getSerialList();
				this.getModelList();
			},
			'vehicleInfo.serialId'(){
				this.getModelList();
			}
		},
		validations: {
			vehicleInfo:{
				dispatcherPhone:{
					required
				},
				style:{
					required
				},
				plateNumber:{
					required
				}
			}
		},
		methods:{
			unBindBtn(){
				if(!this.vehicleInfo.driverId) return;
				this.openModal('unBind');
				return false;
			},
			//强制解绑函数
			forceUnbind(){
				let params = {
					driverId: this.vehicleInfo.driverId,
					vehicleId: this.vehicleId
				}
				this.$http.post(process.env.API_INSURANCE_ROOT + '/rescue-api/driver/forceUnbind',params,{emulateJSON: true})
				.then(res => {
					if(res.data.success){
						this.$parent.openModal("解绑成功");
						this.getvehicleInfo();
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
				this.closeModal("unBind");
			},
			removeCar(){
				this.$http.delete(process.env.API_INSURANCE_ROOT + '/rescue-api/vehicles/'+this.$parent.resultVehicle.vehicleId)
				.then(res => {
					if(res.data.success){
						this.$parent.openModal("删除成功");
						// 关闭当前tab
						for(var i = 0; i < this.$store.state.home.tabList.length; i++) {
							if(this.$store.state.home.tabList[i].name == ("VE" + this.vehicleId)){
							 	this.$store.dispatch('closeTab',i);
		                        this.$router.push(this.$store.state.home.path);
//		                        this.$store.dispatch('setorderstatus');
							}
						}
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})
			},
			
			
			
			
			//上传图片相关
			imageuploaded(res){
				if(res.success){
					this.logoSrc = process.env.PIC_PATH + res.data;//传给后台的信息
					this.vehicleInfo.vehicleLogourl = res.data
				//	this.logoSrc = process.env.PIC_PATH + res.data;
				}else{
					this.messageStr = INFO_EXCEPTION.replace('{1}','上传图片');
					this.$parent.openModal(messageStr);
				}
			},
			strService(){
				let tempArr=[];
				// 路修车，不能选拖车
				if(this.vehicleInfo.style == 11) {
					this.serviceArr[0].type = false;
				}
				this.serviceArr.map(item=>{
					if(item.type){
						tempArr.push(item.udccode);
					}
				})
				this.vehicleInfo.rescueType=tempArr.join(',');
			},
			saveVehicle(){
				// if(!/^[1-9]\d*$/.test(this.vehicleInfo.maximumLoad)){
				// 	return
				// }
				this.$v.vehicleInfo.$touch();
				if(this.$v.$error == true) return;
				this.loadingstatus=true;
				this.strService();
				//this.vehicleInfo.maximumLoadStr = parseInt(this.vehicleInfo.maximumLoadStr)
				let para = {
					vehicleId:this.vehicleId,
					plateNumber:this.vehicleInfo.plateNumber,
					rescueType:this.vehicleInfo.rescueType,
					style:this.vehicleInfo.style,
					maximumLoadStr:this.vehicleInfo.maximumLoadStr,
					dispatcherPhone:this.vehicleInfo.dispatcherPhone,
					logoSrc : this.vehicleInfo.vehicleLogourl,
					memo:this.vehicleInfo.memo
				}
				this.$http.put(process.env.API_INSURANCE_ROOT+'/rescue-api/vehicles',para)
				.then(res=>{
					if(res.body.success){
						this.$parent.openModal("保存成功");
						this.loadingstatus=false;
					}else{
						this.$parent.openModal(res.data.message);
						this.loadingstatus=false;
					}
					this.loadingstatus=false;
				},res=>{
					this.$parent.openModal(res.data.message);
					this.loadingstatus = false
				})
			},
			changeStatus(val){
				this.loadingstatus = true;
				let para={
					serverStatus : val,
					vehicleId : this.$parent.resultVehicle.vehicleId
				}
				this.$http.post(process.env.API_INSURANCE_ROOT + "/rescue-api/vehicles/modify/serviceStatus",para,{emulateJSON: true})
				.then(res=>{
					this.loadingstatus = false;
					if(res.data.success){
						this.getvehicleInfo();
					}else{
						this.$parent.openModal(res.data.message);
					}
				},res=>{
					this.$parent.openModal(res.data.message);
					this.loadingstatus=false;
				})
//				.catch(res=>{
//					this.$parent.openModal(res.data.message);
//					this.loadingstatus = false;
//				})
			},
			getUdc(){
				this.$http.get(process.env.API_ROOT  + '/system/udcs/license/2',{params:{udcTypes:'RESCUE_TYPE,STYLE' },headers:this.token})
				.then(res => {
					if(res.body.success){	
						let obj = res.body.data
						for(let k of obj.STYLE){
							this.udcList.push(k)
						}
						for(let k of obj.RESCUE_TYPE){
							k.type = false;
							this.serviceArr.push(k)
						}
						this.getvehicleInfo();
					}else{
						this.openModalMsg(res.body.message);
					}
				}, res => {
					this.openModalMsg(res.body.message);
					if(res.body.message==''){
						this.openModalMsg('请求出问题啦');
					}
					
				}).catch( res => { 
					this.openModalMsg('请求异常');
				})
			},
			//获取车辆详情
			getvehicleInfo(){
				this.loadingstatus=true;
				this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/vehicles/'+this.vehicleId)
				.then(res => {
					if(res.body.success){
						const that = this
						this.vehicleInfo = res.body.data;
						this.logoSrc = res.body.data.vehicleLogourl == ''? '' : process.env.PIC_PATH + res.body.data.vehicleLogourl
						this.vehicleInfo.vehicleLogourl = res.body.data.vehicleLogourl
						this.serviceArr.map(item => item.type=false)
						this.vehicleInfo.rescueType.split(',').map(item=>{
							for(let k of that.serviceArr){
								if(k.udccode == item){
									k.type = true;
								}
							}
						})
						if(this.vehicleInfo.style == 0){
							this.vehicleInfo.style = "";
						}
						this.loadingstatus=false;
					}else{
						this.loadingstatus=false;
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.loadingstatus=false;
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.loadingstatus=false;
				})	
			},
			//弹出框相关控制
			closeModal(ref) {
				this.$refs[ref].close();
				if(ref=='unBind'||ref=='deleteCar'){
					this.toShowMsg = false;
				}
			},
			openModal(ref){
				this.$refs[ref].open();
				if(ref=='unBind'||ref=='deleteCar'){
					this.toShowMsg = true;
				}
			}
		}
	}
</script>
<style type="text/css" scoped>
.upload-pic{
    	width:100px;
    	height:100px;
    	text-align:center;
    	font-size:16px;
    	line-height: 100px;
    	color:#46AC89; 
    	background-image:url(../../../../assets/project/images/upload_pic.png);
    	background-size:contain;
    	background-position:center;
    	cursor:pointer;
    }
</style>


// WEBPACK FOOTER //
// DetailBasic.vue?548a0b9c